<button type="button" mat-icon-button class="w-100" (click)="onClick()" [class]="theme.myIconColor">
        <mat-icon>{{icon}}</mat-icon>
</button>
